import React from 'react';
import theme from '@theme';

interface QRCodeIconProps {
  fill?: string;
}

const QRCodeIcon = ({ fill = theme.palette.common.white }: QRCodeIconProps) => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.833336 3.66671V0.333374H4.16667V1.66671H2.16667V3.66671H0.833336ZM0.833336 13.6667V10.3334H2.16667V12.3334H4.16667V13.6667H0.833336ZM10.8333 13.6667V12.3334H12.8333V10.3334H14.1667V13.6667H10.8333ZM12.8333 3.66671V1.66671H10.8333V0.333374H14.1667V3.66671H12.8333ZM11.1667 10.6667H12.1667V11.6667H11.1667V10.6667ZM11.1667 8.66671H12.1667V9.66671H11.1667V8.66671ZM10.1667 9.66671H11.1667V10.6667H10.1667V9.66671ZM9.16667 10.6667H10.1667V11.6667H9.16667V10.6667ZM8.16667 9.66671H9.16667V10.6667H8.16667V9.66671ZM10.1667 7.66671H11.1667V8.66671H10.1667V7.66671ZM9.16667 8.66671H10.1667V9.66671H9.16667V8.66671ZM8.16667 7.66671H9.16667V8.66671H8.16667V7.66671ZM12.1667 2.33337V6.33337H8.16667V2.33337H12.1667ZM6.83334 7.66671V11.6667H2.83334V7.66671H6.83334ZM6.83334 2.33337V6.33337H2.83334V2.33337H6.83334ZM5.83334 10.6667V8.66671H3.83334V10.6667H5.83334ZM5.83334 5.33337V3.33337H3.83334V5.33337H5.83334ZM11.1667 5.33337V3.33337H9.16667V5.33337H11.1667Z"
      fill={fill}
    />
  </svg>
);

export default QRCodeIcon;
